var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-timeline",
        { staticClass: "my-timeline" },
        _vm._l(_vm.timeline, function (item, index) {
          return _c(
            "el-timeline-item",
            {
              key: index,
              class:
                "item-process item-process-" +
                _vm.operatorStatus(item.type, item.descInfo).line,
              attrs: { icon: "user-photo-" + item.type, size: "large" },
            },
            [
              item.type === "START"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        _c("span", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(item.userInfo)),
                        ]),
                      ]),
                      _c("div", { staticClass: "status suc" }, [
                        _vm._v("发起审批"),
                      ]),
                    ]),
                    _c("div", { staticClass: "operator-time" }, [
                      _vm._v(_vm._s(item.createTime)),
                    ]),
                    item.content
                      ? _c("div", { staticClass: "comment" }, [
                          _vm._v(_vm._s(item.content)),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "user-icon i-suc" }),
                  ]
                : _vm._e(),
              item.type === "REVOKE"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        _c("span", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(item.userInfo)),
                        ]),
                      ]),
                      _c("div", { staticClass: "status" }, [_vm._v("已撤销")]),
                    ]),
                    _c("div", { staticClass: "operator-time" }, [
                      _vm._v(_vm._s(item.createTime)),
                    ]),
                    _c("div", { staticClass: "user-icon i-cancel" }),
                  ]
                : _vm._e(),
              item.type === "TRANSFER"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        _c("span", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(item.userInfo)),
                        ]),
                      ]),
                      item.operatorId
                        ? _c("div", { staticClass: "status" }, [_vm._v("转交")])
                        : _vm._e(),
                    ]),
                    item.transferUser
                      ? _c("div", { staticClass: "transfer-user" }, [
                          _vm._v(_vm._s(item.transferUser)),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "operator-time" }, [
                      _vm._v(_vm._s(item.createTime)),
                    ]),
                    item.content
                      ? _c(
                          "div",
                          { staticClass: "comment" },
                          [
                            item.operatorId
                              ? [_vm._v(_vm._s(item.content))]
                              : [
                                  _c("span", { staticClass: "err" }, [
                                    _vm._v("未找到" + _vm._s(item.nodeName)),
                                  ]),
                                  _vm._v(
                                    "，已自动转交给 " +
                                      _vm._s(item.newUser) +
                                      " "
                                  ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                    item.operatorId
                      ? _c("div", { staticClass: "user-icon i-zhuanjiao" })
                      : _c("div", { staticClass: "user-icon i-zidong" }),
                  ]
                : _vm._e(),
              item.type === "SIGN"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        _c("span", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(item.userInfo)),
                        ]),
                      ]),
                      _c("div", { staticClass: "status" }, [
                        _vm._v("添加审批人"),
                      ]),
                    ]),
                    _c("div", { staticClass: "transfer-user" }, [
                      _vm._v(_vm._s(item.signUser)),
                    ]),
                    _c("div", { staticClass: "operator-time" }, [
                      _vm._v(_vm._s(item.createTime)),
                    ]),
                    item.content
                      ? _c("div", { staticClass: "comment" }, [
                          _vm._v(_vm._s(item.content)),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "user-icon i-suc" }),
                  ]
                : _vm._e(),
              item.type === "COMMENT"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        _c("span", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(item.userInfo)),
                        ]),
                      ]),
                      _c("div", { staticClass: "status suc" }, [
                        _vm._v("评论"),
                      ]),
                    ]),
                    _c("div", { staticClass: "operator-time" }, [
                      _vm._v(_vm._s(item.createTime)),
                    ]),
                    item.content
                      ? _c("div", { staticClass: "comment" }, [
                          _vm._v(" " + _vm._s(item.content) + " "),
                          item.imageUrls && item.imageUrls.length > 0
                            ? _c(
                                "div",
                                { staticClass: "img-list" },
                                _vm._l(item.imageUrls, function (src, key) {
                                  return _c(
                                    "div",
                                    { key: key, staticClass: "item-img" },
                                    [
                                      _c("img", {
                                        staticClass: "img",
                                        attrs: {
                                          src: src,
                                          width: "80",
                                          height: "80",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "preview-bg",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handlePictureCardPreview(
                                                src
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-zoom-in",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "user-icon i-comment" }),
                  ]
                : _vm._e(),
              item.type === "APPROVE"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        _c("span", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(item.userInfo)),
                        ]),
                        item.signText
                          ? _c("span", { staticClass: "suc" }, [
                              _vm._v(_vm._s(item.signText)),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "div",
                        {
                          class: [
                            "status",
                            _vm.operatorStatus(item.type, item.descInfo).class,
                          ],
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.operatorStatus(item.type, item.descInfo).text
                            )
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "operator-time" }, [
                      _vm._v(_vm._s(item.createTime || item.nowTime)),
                    ]),
                    item.content
                      ? _c(
                          "div",
                          { staticClass: "comment" },
                          [
                            item.noUser
                              ? [
                                  _c("span", { staticClass: "err" }, [
                                    _vm._v("未找到审批人"),
                                  ]),
                                  _vm._v("，" + _vm._s(item.noUserText)),
                                ]
                              : [_vm._v(_vm._s(item.content))],
                          ],
                          2
                        )
                      : _vm._e(),
                    _c("div", {
                      class: [
                        "user-icon ",
                        "i-" +
                          _vm.operatorStatus(item.type, item.descInfo).class,
                      ],
                    }),
                  ]
                : _vm._e(),
              item.type === "MULTI_APPROVE"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        _c("span", { staticClass: "user-name" }, [
                          _vm._v(
                            _vm._s(item.userCount) + "人" + _vm._s(item.mode)
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          class: [
                            "status",
                            _vm.operatorStatus(item.type, item.descInfo).class,
                          ],
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.operatorStatus(item.type, item.descInfo).text
                            )
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "user-con" },
                      [
                        !item.showAll
                          ? [
                              _vm._l(
                                item.userInfo.slice(0, 6),
                                function (person, index2) {
                                  return _c(
                                    "span",
                                    { key: index2 },
                                    [
                                      _vm._v(" " + _vm._s(person.name) + " "),
                                      index2 !== 5 ? [_vm._v("、")] : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "more suc",
                                  on: {
                                    click: function ($event) {
                                      item.showAll = true
                                    },
                                  },
                                },
                                [_vm._v("查看全部>")]
                              ),
                            ]
                          : _vm._l(item.userInfo, function (person, index2) {
                              return _c(
                                "span",
                                { key: index2 },
                                [
                                  _vm._v(" " + _vm._s(person.name) + " "),
                                  index2 != +item.userCount - 1
                                    ? [_vm._v("、")]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "operator-time" }, [
                      _vm._v(_vm._s(item.createTime || item.nowTime)),
                    ]),
                    _c("div", {
                      class: [
                        "user-icon ",
                        "i-" +
                          _vm.operatorStatus(item.type, item.descInfo).class,
                      ],
                    }),
                  ]
                : _vm._e(),
              item.type === "ORSIGNCC"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        _c("span", { staticClass: "user-name" }, [
                          _vm._v("抄送或签" + _vm._s(item.userCount) + "人 "),
                          _c("span", { class: item.read.color }, [
                            _vm._v("(" + _vm._s(item.read.text) + ")"),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "user-con" },
                      [
                        !item.showAll
                          ? [
                              _vm._l(
                                item.userInfo.slice(0, 6),
                                function (person, index2) {
                                  return _c(
                                    "span",
                                    { key: index2 },
                                    [
                                      _vm._v(" " + _vm._s(person.name) + " "),
                                      item.createTime
                                        ? [
                                            person.isRead == 1
                                              ? _c(
                                                  "span",
                                                  { staticClass: "suc" },
                                                  [_vm._v("(已读)")]
                                                )
                                              : _c("span", [_vm._v("(未读)")]),
                                          ]
                                        : _vm._e(),
                                      index2 !== 5 ? [_vm._v("、")] : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "more suc",
                                  on: {
                                    click: function ($event) {
                                      item.showAll = true
                                    },
                                  },
                                },
                                [_vm._v("查看全部>")]
                              ),
                            ]
                          : _vm._l(item.userInfo, function (person, index2) {
                              return _c(
                                "span",
                                { key: index2 },
                                [
                                  _vm._v(" " + _vm._s(person.name) + " "),
                                  item.createTime
                                    ? [
                                        person.isRead == 1
                                          ? _c("span", { staticClass: "suc" }, [
                                              _vm._v("(已读)"),
                                            ])
                                          : _c("span", [_vm._v("(未读)")]),
                                      ]
                                    : _vm._e(),
                                  index2 != +item.userCount - 1
                                    ? [_vm._v("、")]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "operator-time" }, [
                      _vm._v(_vm._s(item.createTime || item.nowTime)),
                    ]),
                    item.createTime
                      ? _c("div", {
                          class: ["user-icon ", "i-" + item.read.icon],
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
              item.type === "CC"
                ? [
                    _c("div", { staticClass: "title-con" }, [
                      _c("div", [
                        _c("span", { staticClass: "operator-name" }, [
                          _vm._v(_vm._s(item.nodeName)),
                        ]),
                        item.createTime
                          ? _c("span", { staticClass: "user-name" }, [
                              _vm._v("已抄送" + _vm._s(item.userCount) + "人"),
                              _c("span", { class: item.read.color }, [
                                _vm._v("(" + _vm._s(item.read.text) + ")"),
                              ]),
                            ])
                          : _c("span", { staticClass: "user-name" }, [
                              _vm._v("抄送" + _vm._s(item.userCount) + "人"),
                            ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "user-name" },
                      [
                        !item.showAll
                          ? [
                              _vm._l(
                                item.userInfo.slice(0, 6),
                                function (person, index2) {
                                  return _c(
                                    "span",
                                    { key: index2 },
                                    [
                                      _vm._v(" " + _vm._s(person.name) + " "),
                                      item.createTime
                                        ? [
                                            person.isRead == 1
                                              ? _c(
                                                  "span",
                                                  { staticClass: "suc" },
                                                  [_vm._v("(已读)")]
                                                )
                                              : _c("span", [_vm._v("(未读)")]),
                                          ]
                                        : _vm._e(),
                                      index2 !== 5 ? [_vm._v("、")] : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "more suc",
                                  on: {
                                    click: function ($event) {
                                      item.showAll = true
                                    },
                                  },
                                },
                                [_vm._v("查看全部>")]
                              ),
                            ]
                          : _vm._l(item.userInfo, function (person, index2) {
                              return _c(
                                "span",
                                { key: index2 },
                                [
                                  _vm._v(" " + _vm._s(person.name) + " "),
                                  item.createTime
                                    ? [
                                        person.isRead == 1
                                          ? _c("span", { staticClass: "suc" }, [
                                              _vm._v("(已读)"),
                                            ])
                                          : _c("span", [_vm._v("(未读)")]),
                                      ]
                                    : _vm._e(),
                                  index2 != +item.userCount - 1
                                    ? [_vm._v("、")]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                      ],
                      2
                    ),
                    item.createTime
                      ? _c("div", { staticClass: "operator-time" }, [
                          _vm._v(_vm._s(item.createTime)),
                        ])
                      : _vm._e(),
                    item.createTime
                      ? _c("div", {
                          class: ["user-icon ", "i-" + item.read.icon],
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }